var _path, _circle, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMentalhealthGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 22.5241V29.3336H20V25.5241H22.3333C23.9902 25.5241 25.3333 24.181 25.3333 22.5241V17.9051H28L25.3333 13.4606V13.2861C25.3333 13.2216 25.3313 13.1577 25.3273 13.0943C25.1364 7.30276 20.4366 2.66699 14.6667 2.66699C8.77563 2.66699 4 7.49947 4 13.4606C4 16.8693 5.56143 19.9088 8 21.8869V22.5241Z",
    fill: "url(#paint0_linear_25971_1670)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6667,
    cy: 13.3337,
    r: 6.66667,
    fill: "#FAFAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9109 10.9136L13.8541 14.7414L12.1085 13.0943C11.7889 12.7927 11.248 12.7927 10.9038 13.0943C10.5842 13.3959 10.5842 13.9063 10.9038 14.2311L13.2395 16.435C13.4116 16.5974 13.6083 16.667 13.8295 16.667C14.0508 16.667 14.2721 16.5974 14.4196 16.435L19.091 12.0271C19.4106 11.7255 19.4106 11.2152 19.091 10.8904C18.7714 10.5888 18.2305 10.5888 17.9109 10.9136Z",
    fill: "#D2D2D8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25971_1670",
    x1: 15.3333,
    y1: 16.0003,
    x2: 30.8547,
    y2: -0.676005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004,
    stopColor: "#DCDCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    stopColor: "#91919C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMentalhealthGray);
export default __webpack_public_path__ + "static/media/icon-mentalhealth-gray.c305ccac8a5ccd59c0617d01418fb1e3.svg";
export { ForwardRef as ReactComponent };